export const reloadPreviewIframe = () => {
  const iframe = document.getElementById('catalog-preview-iframe') as HTMLIFrameElement;
  if (iframe) {
    iframe.src = iframe.src;
  }
};
